import { Dialog, DialogProps } from '@material-ui/core';
import { CSSProperties, FC, ReactNode } from 'react';
import { useThemeContext } from 'shared/context/themeContext';
import {
  dark as darkColors,
  light as lightColors
} from 'shared/theme/colorTokens';

interface ModalProps {
  open: boolean;
  onClose: () => void;
  title?: ReactNode;
  /** Slot a la derecha del título (ej: icono de editar). */
  headerAction?: ReactNode;
  children: ReactNode;
  /** Botones del modal. Para submitear un <Form> externo usar `form={id}` en el botón. */
  footer?: ReactNode;
  maxWidth?: DialogProps['maxWidth'];
  fullWidth?: boolean;
  paperStyle?: CSSProperties;
}

const Modal: FC<ModalProps> = ({
  open,
  onClose,
  title,
  headerAction,
  children,
  footer,
  maxWidth = 'xs',
  fullWidth = true,
  paperStyle
}) => {
  const { theme } = useThemeContext();
  const isDark = theme === 'dark';

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={maxWidth}
      fullWidth={fullWidth}
      PaperProps={{
        style: {
          backgroundColor: isDark
            ? darkColors.modalBackground
            : lightColors.modalBackground,
          borderRadius: '15px',
          ...paperStyle
        }
      }}
    >
      <div className="flex flex-col gap-4 p-6">
        {(title || headerAction) && (
          <div className="flex items-center justify-between">
            <h2 className="text-lg font-semibold text-ink dark:text-ink-dark">
              {title}
            </h2>
            {headerAction}
          </div>
        )}
        {children}
        {footer && <div className="flex justify-end gap-2 pt-2">{footer}</div>}
      </div>
    </Dialog>
  );
};

export default Modal;
